import { render, staticRenderFns } from "./proceso_reparacion.vue?vue&type=template&id=6f0b658a&scoped=true&"
import script from "./proceso_reparacion.vue?vue&type=script&lang=ts&"
export * from "./proceso_reparacion.vue?vue&type=script&lang=ts&"
import style0 from "./proceso_reparacion.vue?vue&type=style&index=0&id=6f0b658a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b658a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
